import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { ClientOnly } from '@tanstack/react-router'

// CompareMap pulls in leaflet and leaflet-side-by-side, both of which touch
// `window` at module scope. ClientOnly only defers rendering — the lazy()
// boundary is what keeps the import off the server.
const CompareMap = lazy(() =>
  import('~/components/ui/CompareMap').then((m) => ({ default: m.CompareMap })),
)

export const Route = createFileRoute('/compare-map')({
  component: RouteComponent,
})

const MapFallback = () => (
  <div className="h-screen w-full flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4" />
      <div className="text-lg font-medium text-gray-700">Loading map comparison...</div>
      <div className="text-sm text-gray-500 mt-2">Preparing side-by-side view</div>
    </div>
  </div>
)

function RouteComponent() {
  return (
    <div className="h-screen w-full">
      <ClientOnly fallback={<MapFallback />}>
        <Suspense fallback={<MapFallback />}>
          <CompareMap />
        </Suspense>
      </ClientOnly>
    </div>
  )
}
